<template>
  <div>
    <div class="heading-5 font-weight-medium">Connect Wallet</div>
    <div class="mt-8" v-if="isCreating">
      <!-- <div class="d-flex align-center">
        <div class="p-14-r gray--text">01</div>
        <div class="h1-26-m ml-5">Connect Creator</div>
      </div> -->
      <p class="p-14-r darkgray--text mt-3">
        Connect to a wallet that you want to use to create this Safe.
      </p>
      <c-btn v-if="!creator" @click="selectingCreator = true"
        >Connect Wallet</c-btn
      >
      <div v-else class="d-flex align-center">
        <div
          class="p-16-r d-flex align-center border-default rounded-50 px-5"
          style="height:48px"
        >
          {{ creator.address }}
        </div>
        <v-icon
          small
          class="icongray--text ml-5 clickable"
          @click="creator = null"
          >fas fa-trash</v-icon
        >
      </div>
    </div>
    <!-- <div class="mt-8">
      <div class="d-flex align-center">
        <div class="p-14-r gray--text mr-5" v-if="isCreating">02</div>
        <div class="h1-26-m">
          Connect Signer
        </div>
      </div>
      <p class="p-14-r darkgray--text mt-3">
        Connect to a wallet that you want to use to sign transactions for this
        Safe. This wallet must be one of the owners.
      </p>
      <c-btn v-if="!signer" @click="selectingSigner = true"
        >Connect Wallet</c-btn
      >
      <div v-else class="d-flex align-center">
        <div
          class="p-16-r d-flex align-center border-default rounded-50 px-5"
          style="height:48px"
        >
          {{ signer.address }}
        </div>
        <v-icon
          small
          class="icongray--text ml-5 clickable"
          @click="signer = null"
          >fas fa-trash</v-icon
        >
      </div>
    </div> -->
    <div class="mt-10 d-flex align-center justify-space-between">
      <div class="p-14-r darkgray--text clickable" @click="back">Back</div>
      <div class="d-flex justify-end align-center">
        <div class="p-16-m gray--text clickable" @click="cancel">Cancel</div>
        <c-btn @click="nextStep" class="ml-5" :disabled="continueDisabled"
          >Continue</c-btn
        >
      </div>
    </div>
    <connect-modal
      v-if="selectingCreator"
      name="Creator"
      @onClosed="selectingCreator = false"
      @onNext="wallet => (creator = wallet)"
    />
    <!-- <connect-modal
      v-if="selectingSigner"
      name="Signer"
      @onClosed="selectingSigner = false"
      @onNext="wallet => (signer = wallet)"
      :owners="safeInfo.owners"
    /> -->
  </div>
</template>

<script>
import ConnectModal from "./ConnectModal";

export default {
  props: ["safeInfo"],
  components: { ConnectModal },
  computed: {
    isCreating() {
      return !this.safeInfo.safeAddress;
    },
    continueDisabled() {
      // return !this.signer || (this.isCreating && !this.creator)
      return this.isCreating && !this.creator;
    },
  },
  data: () => ({
    creator: null,
    signer: null,
    selectingCreator: false,
    selectingSigner: false,
  }),
  methods: {
    back() {
      if (this.isCreating) {
        return this.$emit("setStep", "2.1");
      }
      this.$emit("setStep", "2.2");
    },
    cancel() {
      this.$store.dispatch("closeAuthModal");
    },
    nextStep() {
      if (this.continueDisabled) return;
      this.$emit("setSafeInfo", {
        signer: this.signer,
        creator: this.creator,
      });
      this.$emit("setStep", "4");
    },
  },
  mounted() {
    if (this.safeInfo.creator) {
      this.creator = this.safeInfo.creator;
    }
    // if (this.safeInfo.signer) {
    //   if (
    //     this.safeInfo.owners.some(
    //       owner =>
    //         String(owner.address).toLowerCase() ===
    //         String(this.safeInfo.signer.address).toLowerCase()
    //     )
    //   ) {
    //     this.signer = this.safeInfo.signer;
    //   }
    // }
  },
};
</script>
